import api from "@/services/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { ListParams } from "../types/common";
import { SaveInformationPayload } from "../types/informationType";

interface InformationListParams extends ListParams {
  type?: string;
  categoryId?: number;
}

export const getInformationList = createAsyncThunk("/information/list", async (params: InformationListParams = {}) => {
  const query = new URLSearchParams();
  if (params.page) query.set("page", String(params.page));
  if (params.limit) query.set("limit", String(params.limit));
  if (params.keyword) query.set("keyword", params.keyword);
  if (params.type) query.set("type", params.type);
  if (params.categoryId) query.set("categoryId", String(params.categoryId));
  const response = (await api.get(`/information?${query.toString()}`)).data;
  return response;
});

export const getInformationDetail = createAsyncThunk("/information/detail", async (id: number) => {
  const response = (await api.get(`/information/${id}`)).data;
  return response;
});

export const saveInformation = createAsyncThunk("/information/save", async (payload: SaveInformationPayload) => {
  const response = (await api.post("/information/action", payload)).data;
  return response;
});

export const deleteInformation = createAsyncThunk("/information/delete", async (id: number) => {
  const response = (await api.get(`/information/delete/${id}`)).data;
  return response;
});
